import type { CSSProperties, MouseEvent } from 'react';

/** Soft pill button for dashboard / auth surfaces */
export function softButtonStyle(options?: {
  disabled?: boolean;
  variant?: 'neutral' | 'primary' | 'google';
}): CSSProperties {
  const disabled = options?.disabled;
  const variant = options?.variant ?? 'neutral';

  if (variant === 'google') {
    return {
      width: '100%',
      padding: '13px 20px',
      background: disabled ? '#f8fafc' : '#ffffff',
      border: '1px solid #cbd5e1',
      borderRadius: '12px',
      color: '#1e293b',
      fontSize: '15px',
      fontWeight: 600,
      cursor: disabled ? 'not-allowed' : 'pointer',
      opacity: disabled ? 0.65 : 1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '12px',
      boxShadow: disabled ? 'none' : '0 2px 4px rgba(15, 23, 42, 0.08), 0 4px 14px rgba(15, 23, 42, 0.06)',
      transition: 'box-shadow 0.2s ease, transform 0.2s ease, border-color 0.2s ease',
      fontFamily: 'inherit',
    };
  }

  if (variant === 'primary') {
    return {
      width: '100%',
      padding: '13px 20px',
      background: disabled
        ? 'linear-gradient(180deg, #fdba74 0%, #fb923c 100%)'
        : 'linear-gradient(180deg, #f97316 0%, #ea580c 100%)',
      border: '1px solid #ea580c',
      borderRadius: '12px',
      color: '#ffffff',
      fontSize: '15px',
      fontWeight: 600,
      cursor: disabled ? 'not-allowed' : 'pointer',
      opacity: disabled ? 0.7 : 1,
      boxShadow: disabled ? 'none' : '0 3px 10px rgba(234, 88, 12, 0.4)',
      transition: 'box-shadow 0.2s ease, transform 0.2s ease, opacity 0.2s ease',
      fontFamily: 'inherit',
    };
  }

  return {
    padding: '9px 16px',
    backgroundColor: disabled ? '#f1f5f9' : '#f8fafc',
    border: '1px solid #cbd5e1',
    borderRadius: '10px',
    color: disabled ? '#94a3b8' : '#334155',
    cursor: disabled ? 'not-allowed' : 'pointer',
    fontSize: '14px',
    fontWeight: 600,
    boxShadow: disabled ? 'none' : '0 2px 4px rgba(15, 23, 42, 0.08)',
    transition: 'box-shadow 0.2s ease, transform 0.2s ease, background-color 0.2s ease, border-color 0.2s ease',
    fontFamily: 'inherit',
  };
}

export const softCardButtonStyle: CSSProperties = {
  backgroundColor: '#ffffff',
  border: '1px solid #cbd5e1',
  borderRadius: '16px',
  padding: '24px',
  cursor: 'pointer',
  textAlign: 'left',
  transition: 'box-shadow 0.25s ease, transform 0.25s ease, border-color 0.25s ease',
  boxShadow: '0 2px 6px rgba(15, 23, 42, 0.07)',
  fontFamily: 'inherit',
};

export function onSoftButtonHover(e: MouseEvent<HTMLButtonElement>, enter: boolean) {
  const el = e.currentTarget;
  if (el.disabled) return;
  if (enter) {
    el.style.boxShadow = '0 5px 18px rgba(15, 23, 42, 0.14)';
    el.style.transform = 'translateY(-1px)';
    el.style.borderColor = '#94a3b8';
  } else {
    el.style.boxShadow = '0 2px 4px rgba(15, 23, 42, 0.08)';
    el.style.transform = 'translateY(0)';
    el.style.borderColor = '#cbd5e1';
  }
}

export function onSoftCardHover(e: MouseEvent<HTMLButtonElement>, enter: boolean) {
  const el = e.currentTarget;
  if (enter) {
    el.style.borderColor = '#fb923c';
    el.style.boxShadow = '0 10px 28px rgba(249, 115, 22, 0.18)';
    el.style.transform = 'translateY(-2px)';
    el.style.backgroundColor = '#fff7ed';
  } else {
    el.style.borderColor = '#cbd5e1';
    el.style.boxShadow = '0 2px 6px rgba(15, 23, 42, 0.07)';
    el.style.transform = 'translateY(0)';
    el.style.backgroundColor = '#ffffff';
  }
}
